
const DefaultRoutePopupWrapper = () =>
  import('~~/_core/collections/components/modals/DefaultRoutePopupWrapper.vue');
const ModalWrapper = () =>
  import('~~/_core/collections/components/modals/ModalWrapper.vue');
const DefaultMessageModal = () =>
  import('~~/_core/collections/components/modals/DefaultMessageModal.vue');
const DefaultModalWrapper = () =>
  import('~~/_core/collections/components/modals/DefaultModalWrapper.vue');

export default {
  data() {
    return {
      modals: [],
    };
  },
  methods: {
    alert({ message, title, btnYes = 'Agree', wrapperProps = {}, ...props }) {
      return new Promise((resolve) => {
        this.$modal.show(
          ModalWrapper,
          {
            component: DefaultMessageModal,
            props: {
              ...props,
              message,
              title,
              buttons: [{ label: btnYes, value: true }],
            },
            wrapperProps,
            close: resolve,
          },
          {
            width: wrapperProps.width,
            classes: [
              'ice_modal_message',
              wrapperProps.classes,
              { fixed_position: wrapperProps.x || wrapperProps.y },
            ],
            styles: {
              ...(wrapperProps.x != null
                ? { left: `${wrapperProps.x}px` }
                : null),
              ...(wrapperProps.y != null
                ? { top: `${wrapperProps.y}px` }
                : null),
            },
            clickToClose:
              wrapperProps.clickCloseOutside != null
                ? wrapperProps.clickCloseOutside
                : true,
          },
          {},
          {
            closed: resolve,
          }
        );
      });
    },
    confirm({
      message,
      title,
      btnYes = 'Agree',
      btnNo = 'Skip',
      wrapperProps = {},
      ...props
    }) {
      return new Promise((resolve) => {
        this.$modal.show(
          ModalWrapper,
          {
            component: DefaultMessageModal,
            props: {
              ...props,
              message,
              title,
              buttons: [
                { label: btnNo, value: false },
                { label: btnYes, value: true },
              ],
            },
            wrapperProps,
            close: resolve,
          },
          {
            width: wrapperProps.width || 300,
            classes: [
              wrapperProps.classes,
              { fixed_position: wrapperProps.x || wrapperProps.y },
            ],
            clickToClose:
              wrapperProps.clickCloseOutside != null
                ? wrapperProps.clickCloseOutside
                : true,
          },
          {},
          {
            closed: resolve,
          }
        );
      });
    },
    show({ component, props, wrapperProps = {}, wrapper }) {
      return new Promise((resolve) => {
        this.$modal.show(
          DefaultRoutePopupWrapper,
          {
            component,
            props,
            wrapperProps,
            close: resolve,
          },
          {
            width: wrapperProps?.width || 480,
            height: wrapperProps?.height,
            classes: [
              wrapperProps.classes,
              { fixed_position: wrapperProps.x || wrapperProps.y },
            ],
            hasCheckToday: wrapperProps.hasCheckToday,
            // styles: {
            //   ...(wrapperProps.x != null ? { left: `${wrapperProps.x}px` } : null),
            //   ...(wrapperProps.y != null ? { top: `${wrapperProps.y}px` } : null),
            // },
            clickToClose:
              wrapperProps.clickCloseOutside != null
                ? wrapperProps.clickCloseOutside
                : true,
          },
          {},
          {
            closed: resolve,
          }
        );
      });
    },
    open({ component, props, wrapperProps = {}, wrapper }) {
      return new Promise((resolve) => {
        this.$modal.show(
          DefaultModalWrapper,
          {
            component,
            props,
            wrapperProps,
            close: resolve,
          },
          {
            width: wrapperProps?.width || 480,
            height: wrapperProps?.height,
            classes: [wrapperProps.classes],
            hasCheckToday: wrapperProps.hasCheckToday,
            styles: {
              ...(wrapperProps['overflow-x'] != null
                ? { 'overflow-x': wrapperProps['overflow-x'] }
                : null),
              ...(wrapperProps['overflow-y'] != null
                ? { 'overflow-y': wrapperProps['overflow-y'] }
                : null),
              ...(wrapperProps['overflow'] != null
                ? { overflow: wrapperProps['overflow'] }
                : null),
            },
            clickToClose:
              wrapperProps.clickCloseOutside != null
                ? wrapperProps.clickCloseOutside
                : true,
          },
          {},
          {
            closed: resolve,
          }
        );
      });
    },
    // Completely close the modal
    close(result, { id }) {
      const target = this.modals.find((i) => i.id == id);
      const bodyClasses = target.body;
      target.resolve(result);
      this.modals = this.modals.filter((i) => i.id != id);

      if (!this.modals.some((i) => i.body == bodyClasses)) {
        document.body.classList.remove(bodyClasses);

        const scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
    },
    // close all modals
    clear() {
      this.modals.forEach((i) => this.close(null, i));
    },
    // Temporary hide all modals
    hideAll({ url }) {
      this.modals.forEach((target) => {
        const bodyClasses = target.body;

        target.hidden = true;
        target.hiddenUrl = url;

        document.body.classList.remove(bodyClasses);
      });

      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    },
    showAll({ url } = {}) {
      this.modals.forEach((target) => {
        if (url && target.hiddenUrl != url) {
          return;
        }

        const bodyClasses = target.body;

        target.hidden = false;

        document.body.style.top = `-${window.scrollY}px`;
        document.body.classList.add(bodyClasses);
      });
    },
  },
  render(h) {
    return h(
      'div',
      {},
      this.modals.map((modal) =>
        h(
          modal.wrapper || 'DefaultModalWrapper',
          {
            props: modal.wrapperProps,
            style: modal.hidden ? 'display:none' : '',
            class: modal.wrapperProps && modal.wrapperProps.class,
            on: {
              close: (e) => this.close(e, { id: modal.id }),
            },
          },
          [
            h(modal.component, {
              props: modal.props,
              on: {
                close: (e) => this.close(e, { id: modal.id }),
              },
            }),
          ]
        )
      )
    );
  },
};
